import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { lazy, Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../components/Dialog';
import { Loading } from '../components/Loading';
import { DIALOG_MODE_LOADING } from '../constants';
import { useIsDesktop } from '../hooks/internal';
import { TranslationKeys } from '../translations';
import { getInitialProduct } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var DialogContent = /*#__PURE__*/lazy(async function () {
  return {
    default: (await import('./DialogContent')).DialogContent
  };
});
export var DialogContainer = function DialogContainer(_ref) {
  var _ref$analytics = _ref.analytics,
    analytics = _ref$analytics === void 0 ? {} : _ref$analytics,
    _ref$customer = _ref.customer,
    customer = _ref$customer === void 0 ? {} : _ref$customer,
    _ref$dialog = _ref.dialog,
    dialog = _ref$dialog === void 0 ? {} : _ref$dialog,
    _ref$handlers = _ref.handlers,
    handlers = _ref$handlers === void 0 ? {} : _ref$handlers,
    initialProductCode = _ref.initialProductCode,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? DIALOG_MODE_LOADING : _ref$mode,
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    _ref$shared = _ref.shared,
    shared = _ref$shared === void 0 ? {} : _ref$shared;
  var originalItemCode = shared.originalItemCode;
  var _getInitialProduct = getInitialProduct({
      initialProductCode: initialProductCode,
      products: products
    }),
    product = _getInitialProduct.product;
  var _ref2 = product !== null && product !== void 0 ? product : {},
    canBeReserved = _ref2.canBeReserved;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    translate = _useTranslation2[0];
  var isDesktop = useIsDesktop();
  var header = useMemo(function () {
    if (!isDesktop) {
      if (originalItemCode) {
        return translate(TranslationKeys.ReplaceWith);
      }
      if (canBeReserved) {
        return translate(TranslationKeys.Reserve);
      }
    }
    return undefined;
  }, [canBeReserved, isDesktop, originalItemCode, translate]);
  return /*#__PURE__*/_jsx(Dialog, _objectSpread(_objectSpread({
    header: header
  }, dialog), {}, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(Loading, {}),
      children: mode === DIALOG_MODE_LOADING ? /*#__PURE__*/_jsx(Loading, {}) : /*#__PURE__*/_jsx(DialogContent, {
        analytics: analytics,
        customer: customer,
        handlers: handlers,
        initialProductCode: initialProductCode,
        mode: mode,
        products: products,
        shared: shared
      })
    })
  }));
};